import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class CanActivateAuthentication implements CanActivate {
  constructor(private router: Router, private service: AuthenticationService) {}

  /**Determine wether user is LogedIn and Activate Pages accordingly */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      if (this.service.isLogged) {
        if (state.url.indexOf('welcome') !== -1) {
          this.router.navigateByUrl('/dashboard');
          return false;
        }
        return true;
      }

      if (state.url.indexOf('welcome') !== -1) {
        return true;
      }

      this.router.navigateByUrl('/welcome');
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/authentication/authentication-can-activate.guard.ts